import {createContext} from "react";
import {DESKTOP} from "../actions/mobile";

export const PlatformContext = createContext({
    platform: DESKTOP,
    setPlatform: () => {}, // Placeholder function
});


// WEBPACK FOOTER //
// ./src/context/PlatformContext.js